/**
 * Blog Configuration
 *
 * This file centralizes all blog settings making it easy for any developer
 * to customize the blog without touching component code.
 */

import Config from "../Config";

export const BlogConfig = {
  // Basic blog info - pulls from main Config.js
  title: "Blog",
  subtitle: "Thoughts on software design, patterns, and architecture",
  author: Config.name || "Your Name",
  authorBio: Config.resume?.headline || "Software engineer passionate about clean code and scalable systems.",

  // SEO defaults
  seo: {
    titleTemplate: "%s | Diego Garcia",
    defaultDescription:
      "A blog about software engineering, design patterns, and system architecture.",
    siteUrl: "https://diegogarcia.ca",
  },

  // Content settings
  content: {
    postsPerPage: 10,
    postsDirectory: "/content/posts",
    defaultThumbnail: null,
    dateFormat: "MMM dd, yyyy",
    featuredPostsCount: 3,
  },

  // Feature toggles
  features: {
    enableSearch: true,
    enableTags: true,
    enableCategories: true,
    enableReadingTime: true,
    enableComments: false,
    enableNewsletter: false,
    enableSocialShare: true,
    showFeaturedOnHome: true,
  },

  // Navigation
  navigation: {
    blogLabel: "Blog",
    homeLabel: "Home",
    resumeLabel: "Resume",
    showMinimalNav: true,
  },

  // Social sharing - pulls from main Config.js
  social: {
    twitterHandle: Config.socialMediaUrl?.x?.replace("https://twitter.com/", "") || "@yourhandle",
    linkedinUrl: Config.socialMediaUrl?.linkedin || "",
    githubUrl: Config.socialMediaUrl?.github || "",
    xUrl: Config.socialMediaUrl?.x || "",
  },

  // Categories for the blog
  categories: [
    { id: "design-patterns", label: "Design Patterns", color: "#3b82f6" },
    {
      id: "system-architecture",
      label: "System Architecture",
      color: "#8b5cf6",
    },
    { id: "frontend-patterns", label: "Frontend Patterns", color: "#10b981" },
    { id: "tooling", label: "Tooling", color: "#f59e0b" },
    { id: "best-practices", label: "Best Practices", color: "#ef4444" },
  ],

  // Code highlighting theme (prism-react-renderer themes)
  codeTheme: "github",

  // Date formatting options
  dateOptions: {
    year: "numeric",
    month: "short",
    day: "2-digit",
  },
};

export default BlogConfig;
